<script>
import { onMount } from 'svelte'
import { Link } from "svelte-routing";
import Nav from "../widget/Navbar.svelte";
 
const apiURL = 'https://axcora.my.id/pos-x/API/frontend/connect.php';
	let data = [];onMount(async function() {const response = await fetch(apiURL);data = await response.json();});
	
	
</script>
<Nav/>
<div class="container">

<div class="row">
  <div class="col-md-12 p-3 p-md-5">
    <h2 class="sr-only">Products</h2>
	</div>
    <div class="row">
{#each data as item}	
      <a class="text-dark col-md-4 p-3" 
	 href="https://wa.me/{item.whatsapp}?text={item.title}%0A{item.description}%0A{item.intro} %0A{item.name} - Rp.{item.price}%0A{item.nama}%0A{item.alamat}%0A{item.phone}%0ATata Cara Pembayaran%0A{item.bank}%0A{item.norek}%0A{item.an}%0A{item.konfirm}%0A{item.penutup}">
                  <img src="https://axcora.my.id/pos-x/uploads/{item.image}" alt="{item.name}" class="img-fluid">
      <div class="p-3">
        <h3 class="mt-3">
         {item.name}
        </h3>
        <p class="mt-3">
      Rp.{item.price}
        </p>
    </div>
      </a>
	{/each}

    </div>
    </div>
 </div>
